import { useQuery } from "@tanstack/react-query";
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-adapter-date-fns";
import { Line } from "react-chartjs-2";
import { getInsightsVisitAvgByWeek } from "../../actions/acc_actions";
import Loading from "../../utils/Loading";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  TimeScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
);

const ActiveUserChart = ({ dateTo, dateFrom, selectedSchema }) => {
  const { isLoading, data: insightsData } = useQuery({
    queryKey: ["insightsVisitAvgByWeek", selectedSchema, dateFrom, dateTo],
    queryFn: () =>
      getInsightsVisitAvgByWeek({
        to: dateTo,
        from: dateFrom,
        refresh: false,
        loyalty_scheme_slug: selectedSchema,
      }),
    enabled: Boolean(dateTo && dateFrom && selectedSchema),
    keepPreviousData: true,
  });

  if (isLoading) return <Loading />;

  const chartData = insightsData?.body?.data ?? [];
  if (!chartData.length) return <div>No data available</div>;

  // ✅ Extract just the date string
  const labels = chartData.map((item) => item.start_of_week_iso.value);

  const datasetsConfig = [
    {
      label: "Active Customers",
      data: chartData.map((item) => item.active_customers),
      borderColor: "#1890ff",
      backgroundColor: "rgba(24, 144, 255, 0.2)",
    },
    {
      label: "Actual Visits",
      data: chartData.map((item) => item.actual_visits),
      borderColor: "#52c41a",
      backgroundColor: "rgba(82, 196, 26, 0.2)",
    },
    {
      label: "Avg Visits per Active Customer",
      data: chartData.map((item) => item.avg_visits_per_active_customer),
      borderColor: "#fa8c16",
      backgroundColor: "rgba(250, 140, 22, 0.2)",
    },
  ];

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: "time",
        time: {
          unit: "week",
          displayFormats: { week: "MMM dd" },
        },
        title: {
          display: true,
          text: "Week Starting",
        },
      },
      y: {
        beginAtZero: true,
        title: { display: true, text: "Value" },
      },
    },
    plugins: {
      legend: { position: "top" },
      tooltip: { mode: "index", intersect: false },
    },
  };

  return (
    <div className="active-user-chart-container chart">
      <h3>Active User Data</h3>
      <div className="charts-wrapper">
        {datasetsConfig.map(({ label, data, borderColor, backgroundColor }) => (
          <div className="chart-item" key={label}>
            <h4>{label}</h4>
            <div className="chart-container" style={{ height: "300px" }}>
              <Line
                data={{
                  labels,
                  datasets: [
                    {
                      label,
                      data,
                      borderColor,
                      backgroundColor,
                      fill: true,
                      tension: 0.4,
                    },
                  ],
                }}
                options={chartOptions}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActiveUserChart;
